var map = {
	"./adult/de/ordforstaelse-data.json": 876,
	"./adult/nn/ordforstaelse-data.json": 877,
	"./adult/no/ordforstaelse-data.json": 878,
	"./youth/de/ordforstaelse-data.json": 879,
	"./youth/nn/ordforstaelse-data.json": 880,
	"./youth/no/ordforstaelse-data.json": 881,
	"./youth/se/ordforstaelse-data.json": 882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;